import { useEffect, useState } from 'react';
import AvailabilityTable from './_components/AvailabilityTable';
import InformationTable from './_components/InformationTable';
import Filter from './_components/Filter.tsx';
import CheckAvailabilityButton from './_components/CheckAvailabilityButton';
import Loader from '../../components/Loader';
import { checkAvailability, getDestinations, getSuppliers } from './service.ts';
import {
  AvailabilityItemType,
  DestinationType,
  FilterOptionsType,
  HtiEresSupplierType,
} from './types.ts';
import { toUtcDate } from '../../helpers/toUtcDate.ts';
import { toast } from 'react-toastify';
import { styled } from 'styled-components';
import { StyledRow, StyledTableWrapper } from './_components/AvailabilityTable/styled.ts';
import dayjs from 'dayjs';
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter';

const StyledContainer = styled.div`
  display: inline-block;
  width: 100%;
  padding: 20px 20px 0 20px;
`;

const StyledRelativeContainer = styled.div`
  position: relative;
`;

const StyledTableContainer = styled(StyledTableWrapper)`
  margin-top: 40px;
`;

const LiveAvailability = () => {
  const [destinations, setDestinations] = useState<DestinationType[]>([]);
  const [htiEresSuppliers, setHtiEresSuppliers] = useState<HtiEresSupplierType[]>([]);
  const [liveAvailabilityItems, setLiveAvailabilityItems] = useState<AvailabilityItemType[] | []>(
    [],
  );

  const [filterOptions, setFilterOptions] = useState<FilterOptionsType>({
    EntriesPerPage: 100,
    CurrentPage: 1,
    TotalEntries: 0,
    PageCount: 0,
    SortField: 'Id',
    SortDirect: 'desc',
    DestinationId: null,
    HtiEresSupplierId: null,
    StartDate: new Date(),
    CountOfNights: null,
    CountOfRooms: null,
  });

  const [isLoading, setIsLoading] = useState<boolean>(false);

  const getAllLiveAvailability = async () => {
    setIsLoading(true);
    const body = { ...filterOptions };
    body.StartDate = toUtcDate(filterOptions.StartDate);
    const availabilityItems = await checkAvailability(body);
    if (!availabilityItems)
      toast('Incorrect parameters. Check Nights/Rooms values.', { type: 'error' });
    setLiveAvailabilityItems(availabilityItems || []);
    setIsLoading(false);
  };

  const handleGetHtiEresSuppliers = async (destId: number | null = null) => {
    setIsLoading(true);
    const suppliers = await getSuppliers(destId);
    setHtiEresSuppliers(suppliers || []);
    setIsLoading(false);
  };

  const handleGetDestinations = async () => {
    const currentDestinations = await getDestinations();
    setDestinations(currentDestinations || []);

    handleGetHtiEresSuppliers();
  };

  useEffect(() => {
    setIsLoading(true);
    handleGetDestinations();
    /* eslint-disable react-hooks/exhaustive-deps */
  }, []);

  const dateFromPast = () => {
    dayjs.extend(isSameOrAfter);
    const dayJsObj = dayjs(filterOptions.StartDate);
    const now = dayjs().set('hour', 0).set('minute', 0).set('second', 1);
    return dayJsObj.isSameOrAfter(now);
  };

  return (
    <StyledContainer>
      <StyledRow>
        <div className="col-sm-12">
          <Filter
            destinations={destinations}
            htiEresSuppliers={htiEresSuppliers}
            filterOptions={filterOptions}
            setFilterOptions={setFilterOptions}
            handleGetHtiEresSuppliers={handleGetHtiEresSuppliers}
          />

          <CheckAvailabilityButton
            getAllLiveAvailability={getAllLiveAvailability}
            isDisabled={!filterOptions.StartDate || !dateFromPast()}
          />

          <StyledRow>
            <div className="col-md-10">
              <StyledRelativeContainer>
                {isLoading && <Loader />}

                <StyledTableContainer>
                  <AvailabilityTable liveAvailabilityItems={liveAvailabilityItems} />
                </StyledTableContainer>
              </StyledRelativeContainer>
            </div>

            <InformationTable />
          </StyledRow>
        </div>
      </StyledRow>
    </StyledContainer>
  );
};

export default LiveAvailability;
